module.exports = __webpack_public_path__ + "static/media/galeryFloating5.d0ec2353.jpg";